import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Form, Input, notification } from 'antd';
import axios from 'axios';

import MainLayout from '@/components/Layout/MainLayout';
import useGlobalConfig from '@/store/global';

const ProviderSignIn = () => {
  const { updateMeData, themeColor } = useGlobalConfig();
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      const res = await axios.post('sessions', values);
      localStorage.setItem('Authorization', res.data.auth_token);
      localStorage.setItem('Email', res.data.email);
      localStorage.setItem('point_of_contact', res.data.point_of_contact);
      localStorage.setItem('business_name', res.data.business_name);

      const meData = await axios.get('sessions/me');
      updateMeData(meData.data);
      navigate('/patients');
    } catch (e) {
      console.log(e);
      api.error({
        message: 'Sign in failed, please try again',
      });
    }
  };

  return (
    <MainLayout>
      {contextHolder}
      <div className="my-5 py-5 flex justify-center items-center min-h-[50vh]">
        <Card
          style={{
            width: 450,
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
            borderRadius: 8,
          }}
        >
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold mb-6 text-center"
              style={{ color: themeColor }}
            >
              Provider Sign In
            </h2>
            <Form name="normal_login" initialValues={{ remember: true }} onFinish={onFinish}>
              <Form.Item
                name="email"
                rules={[{ required: true, message: 'Please input your Email!' }]}
              >
                <Input
                  name="email"
                  prefix={<UserOutlined />}
                  placeholder="Email Address"
                  size="large"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your Password!' }]}
              >
                <Input
                  name="password"
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  size="large"
                />
              </Form.Item>
              <Form.Item>
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  style={{
                    height: 40,
                    fontSize: 18,
                    fontWeight: 500,
                    borderRadius: 4,
                    background: themeColor,
                    border: 'none',
                    boxShadow: '0 4px 6px',
                  }}
                >
                  Sign in
                </Button>
              </Form.Item>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
                <Link to="/signup">Provider Register</Link>
                <Link to="/forgot-password">Forgot password?</Link>
              </div>
            </Form>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default ProviderSignIn;
